import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import {
    Checkbox,
    Divider,
    FormControlLabel,
    Snackbar,
} from "@material-ui/core";

import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";

import AutoForm from "../form/functional/AutoForm";
import { getColumnNameArrayPerProcess, getNum, getProcessName } from "../../lib/TkPopUtils/TkPopProductMangeDetailUtils";
import { cloneDeep } from 'lodash';
import defineConf from "../../config/defineConf";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px",
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text,
    },
}));

function TkPopProductDetailCommonDialog(props) {
    const classes = useStyles();

    const {
        id,
        mode,
        schema,
        refresh,

        initialData,

        onSelectMst,
        detailList,

        title,
        formId,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onInitialized,
        onSuccess,
        onClose,

        onDialogUpdateDetail,

        appendCheckBox,

        processCode,

        detailSeletMst,

        update,

        ...others
    } = props;

    const [keepOpen, setKeepOpen] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [formData, setFormData] = useState({});
    const [instance, setInstance] = useState();

    const [, setHeight] = useState(0);

    const [num, setNum] = useState();


    const [formSchema, setFormSchema] = useState({});
    const [isTimeForm, setIsTimeForm] = useState(true);


    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (initialData) {

            let newinitialData = cloneDeep(initialData);

            setFormData(newinitialData);
        }

    }, [initialData]);

    useEffect(() => {
        if (!update) {


            (async () => {

                if (others.open && onSelectMst && (["PR008", "PR009", "PR011"]).includes(processCode)) {

                    if (processCode === "PR011") {

                        setNum(await getNum(onSelectMst.parentPlanId, "방전(NC)"));

                    } else {

                        setNum(await getNum(onSelectMst.parentPlanId, onSelectMst.processName));

                    }

                } else {

                    setNum(undefined);

                }

            })();
        }
    }, [id, onSelectMst, others.open, update, processCode])

    useEffect(() => {

        setDisabled(false);

        if (!update) {

            setFormData((prevFormData) => {

                let newFormData = {
                    ...prevFormData,
                    planId: onSelectMst?.planId,
                    processCode: processCode,
                    num: num,
                    size: defineConf.sizeType.SMALL

                }

                if (processCode === "CAM") {
                    delete newFormData.size;
                }

                return newFormData
            })
        }

    }, [num, update, onSelectMst?.planId, processCode])

    useEffect(() => {
        if (schema) {
            /* PR002 =  밀링 PR003 = 연마 */
            if (["PR002", "PR003"].includes(processCode)) {

                let processColumnLists = getColumnNameArrayPerProcess(getProcessName(processCode));

                let commonColumnExceptionList = processColumnLists.filter((name) => !["workers", "workTime", "size", "isRepair"].includes(name));

                let newSchema = cloneDeep(schema);

                if (isTimeForm) {

                    for (let column of newSchema.columns) {

                        if (commonColumnExceptionList.includes(column.name)) {

                            column.hideInForm = true;

                        }
                    }

                    setFormData((prev) => {
                        // console.log({ ...prev, ...initialData, ...commonColumnExceptionList.reduce((prev, current) => { return { ...prev, [current]: null } }, {}) })
                        return { ...prev, ...initialData, ...commonColumnExceptionList.reduce((prev, current) => { return { ...prev, [current]: null } }, {}) }

                    });

                } else {

                    for (let column of newSchema.columns) {
                        switch (column.name) {
                            case "workTime":
                                column.hideInForm = true;
                                break;
                            default:
                                break;
                        }
                    }
                    setFormData((prev) => {
                        // console.log({ ...prev, ...initialData, workTime: null })
                        return { ...prev, ...initialData, workTime: null }
                    });
                }
                setFormSchema(newSchema)
            } else {
                setFormSchema(schema)
            }
        }

    }, [schema, processCode, isTimeForm, initialData])

    const { t } = useTranslation();

    const onCloseDialog = () => {

        setFormData({ processCode: processCode, planId: onSelectMst?.planId, num: undefined, size: processCode === "CAM" ? null : defineConf.sizeType.SMALL, workTime: null });

        if (onClose) {
            onClose();
        }
    };

    const onCancel = () => {

        instance.hide();

        setFormData({ processCode: processCode, planId: onSelectMst?.planId, num: undefined, size: processCode === "CAM" ? null : defineConf.sizeType.SMALL, workTime: null });
    };

    const onDialogInitialized = (instance) => {
        setInstance(instance);

        if (onInitialized) {
            onInitialized(instance);
        }
    };

    const onChange = (formData) => {
        // console.log(formData)
        setFormData(formData);

        setDisabled(false);
    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const refreshed = (msg) => {

        notifySuccess(msg);

        if (refresh) {

            refresh.refresh();

        }
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const nofifyWarning = (msg) => {
        console.warn(msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onApiSuccess = async (result) => {

        refreshed();

        if (onSuccess) {

            setTimeout(onSuccess(result.data), 0);

        }
        if (!keepOpen) {

            instance.hide();

        }

        if ((["PR008", "PR009", "PR011"]).includes(processCode)) {

            if (processCode === "PR011") {

                setNum(await getNum(onSelectMst.parentPlanId, "방전(NC)"));

            } else {

                setNum(await getNum(onSelectMst.parentPlanId, onSelectMst.processName));

            }

        }

    };

    const onApiFailure = (reason) => {

        setDisabled(false);

        notifyFailure(
            t("error.insertFailure", {
                reason: reason.response
                    ? reason.response.data
                    : JSON.stringify(reason),
            })
        );
    };

    const checkItemValidation = (schema, formData) => {
        for (const column of schema.columns) {
            let [valid, msg] = checkValidation(
                "create",
                column,
                column.validation,
                formData[column.name] || ""
            );

            if (!valid) {
                nofifyWarning(msg);
                return false;
            }
        }

        return true;
    };

    const onOk = (schema, formData) => {

        if (!checkItemValidation(schema, formData)) {
            console.error(" From Validation Failed ");

            return;
        }

        if (schema.validation) {
            let [valid, msg] = checkConditionWithMsg(
                formData,
                schema.validation
            );

            if (!valid) {
                nofifyWarning(
                    t("warning.formDataValidationFail", { msg: msg })
                );
                return;
            }
        }

        let apiData = { ...formData };
        let workTime = formData?.workTime
        if (!Number.isInteger(workTime)) {
            apiData.workTime = parseFloat(workTime) * 60 * 60;
        }
        let form = new FormData();

        let json = {};
        let deleted = {};


        for (const formItem in apiData) {
            if (apiData[formItem] !== undefined) {
                json[formItem] = apiData[formItem];
            }
        }

        if (update) { // 측정은 수정이 없고 파일이 수정을 방해...
            delete json["testResultsDoc"];
        }

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify(json));

        setDisabled(true);
        if (update) {
            let url = `/api/TkPopProductManageDetail/${formData["planDetailId"]}`;

            apiClient
                .put(url, form, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((result) => onApiSuccess(result))
                .catch((reason) => onApiFailure(reason));
        } else {

            let url = `/api/TkPopProductManageDetail`;

            apiClient
                .post(url, form, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((result) => onApiSuccess(result))
                .catch((reason) => onApiFailure(reason));
        }
    };

    const onCloseNotification = () => {
        setNotification((notification) => {
            return { ...notification, open: false };
        });
    };

    const checkKeepOpen = () => {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={() =>
                                setKeepOpen((keepOpen) => !keepOpen)
                            }
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={
                        <span className={classes.label}>
                            {t("term.keepDialogOpen")}
                        </span>
                    }
                />
                <div style={{ flexGrow: 1 }}></div>
            </>
        );
    };

    let setInitialDataCallback = (newFormData, name, value) => {

        newFormData.planId = onSelectMst?.planId;

        newFormData.processCode = processCode;

        newFormData.workTime = null;
    }

    return (
        <>
            <Dialog
                id={id}
                moveable={moveable ? moveable : uiConf.dialogMoveable}
                resizable={resizable ? resizable : uiConf.dialogResizable}
                fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
                maxWidth={maxWidth ? maxWidth : uiConf.autoFormDialogMaxWidth}
                onClose={onCloseDialog}
                onInitialized={onDialogInitialized}
                {...others}
            >
                <DialogHeader>
                    <DialogTitle style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                        {title}
                        {/* PR002 =  밀링 PR003 = 연마 */}
                        {["PR002", "PR003"].includes(processCode) ?
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        className={classes.keepOpenSwitch}
                                        checked={isTimeForm}
                                        color="primary"
                                        onChange={() =>
                                            setIsTimeForm((timeForm) => !timeForm)
                                        }
                                        name="checkKeepOpen"
                                        size="small"
                                    />
                                }
                                label={
                                    <span className={classes.label}>
                                        {t("term.inputTimeForm")}
                                    </span>
                                }
                            />
                            :
                            <></>
                        }

                    </DialogTitle>
                </DialogHeader>

                <Divider />

                <DialogContent >

                    <AutoForm
                        id="TkInputInspection"
                        schema={formSchema}
                        mode="edit"
                        initialData={formData}
                        onChange={onChange}
                        setInitialDataCallback={setInitialDataCallback}
                    />

                    <Snackbar
                        open={notification.open && notification.severity !== "success"}
                        autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                        onClose={onCloseNotification}
                    >
                        <Alert
                            onClose={onCloseNotification}
                            variant="filled"
                            severity={notification.severity}
                        >
                            {notification.msg}
                        </Alert>
                    </Snackbar>
                </DialogContent>

                <Divider />

                <DialogActionsOkCancel
                    firstActionComponent={checkKeepOpen}
                    labels={[t("common.add")]}
                    buttonDisabled={[disabled, false]}
                    onOk={() => onOk(formSchema, formData)}
                    onCancel={onCancel}
                ></DialogActionsOkCancel>
            </Dialog>
        </>
    );
}

export default TkPopProductDetailCommonDialog;
